import pluck from 'transmute/pluck';
import { createSelector } from 'reselect';
import { getUserTeams } from './getUserTeams';
export const getUserTeamIds = createSelector(getUserTeams,
// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Team[]' is not assignable to par... Remove this comment to see the full error message
teams => pluck('id', teams));